import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function PSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-562">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-563">
        <div data-id="element-564">
          <h2 className="text-3xl font-bold mb-1" data-id="element-565">Bodor P Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-566">
            High-performance fiber laser plate cutting machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-567">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-568">
          <div className="md:col-span-5 flex justify-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-569">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Performance%20Fiber%20Laser%20P%20Series%20Bodor.png800x800.png" alt="Bodor P Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl" data-id="element-570" />
          </div>
          <div className="md:col-span-7" data-id="element-571">
            <ul className="space-y-4 text-gray-700" data-id="element-572">
              <li data-id="element-573">
                <strong className="text-[#f5693d] block text-lg mb-1" data-id="element-574">
                  All-round Model
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-575">
                  Equipped with automatic functions of nozzle changing and
                  one-click processing, P series is competent for all cutting
                  tasks.
                </span>
              </li>
              <li data-id="element-576">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-577">
                  One-click Processing
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-578">
                  All functions of the system are distributed logically and
                  orderly to achieve fully automatic mass production.
                </span>
              </li>
              <li data-id="element-579">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-580">
                  Automatic nozzle changer
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-581">
                  The machine changes its nozzle within 35s at the fastest speed
                  - this saves 50% of time costs.
                </span>
              </li>
              <li data-id="element-582">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-583">
                  Cast Iron Bed
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-584">
                  Featuring good shock absorption, Cast Iron Bed keeps its shape
                  all the way with the optimal mechanical property.
                </span>
              </li>
              <li data-id="element-585">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-586">
                  Active Anti-collision Function
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-587">
                  Effectively reduce the damage rate of laser heads, help you
                  save maintenance cost.
                </span>
              </li>
              <li data-id="element-588">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-589">
                  Expert High Speed Cutting Database
                </strong>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-590">
              <a href="https://www.peakedm.com/m7/Bodor%20P%20Series--p-series-performance-fiber-laser-sheet-cutting.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-591">
                <span className="mr-2" data-id="element-592">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Bodor%20Laser%20P%20series%20brochure.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-593">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-594" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-595">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-596">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-597">
              <tr data-id="element-598">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/4" data-id="element-599">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-600">
                  P3
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-601">
                  P4
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-602">
                  P6 Lean
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-603">
                  P6
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center" data-id="element-604">
                  P8
                </th>
              </tr>
            </thead>
            <tbody data-id="element-605">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-606">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-607">
                  Working Area
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-608">
                  3048*1524mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-609">
                  4000*2000mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-610">
                  6100*2000mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-611">
                  6100*2500mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-612">8100*2500mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-613">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-614">
                  Laser Power
                </th>
                <td colSpan={5} className="px-6 py-4 text-center" data-id="element-615">
                  40000w/30000w/22000w/20000w/12000w/6000w/3000w/2000w/1500w
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-616">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-617">
                  X/Y-axis positioning accuracy
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-618">
                  0.03mm
                </td>
                <td colSpan={4} className="px-6 py-4 text-center" data-id="element-619">
                  0.05mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-620">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-621">
                  X/Y-axis repositioning accuracy
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-622">
                  0.02mm
                </td>
                <td colSpan={4} className="px-6 py-4 text-center" data-id="element-623">
                  0.03mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-624">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-625">
                  X/Y-axis Max. linkage acceleration
                </th>
                <td colSpan={2} className="px-6 py-4 text-center border-r border-gray-200" data-id="element-626">
                  2.5G
                </td>
                <td colSpan={3} className="px-6 py-4 text-center" data-id="element-627">
                  2G
                </td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-628">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-629">
                  X/Y-axis Max. linkage speed
                </th>
                <td colSpan={5} className="px-6 py-4 text-center" data-id="element-630">
                  169m/min
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}